<div class="modal-header">
  <h4 style="padding-right: 4px;" class="modal-title">Azure Namespace</h4>
  <button style="margin-right:4px;" type="button" class="close" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
    <i style="font-size:16px;" class="fas fa-times"></i>
  </button>
</div>

<div class="modal-body">
  <div class="modal-body-inner">
    <form (ngSubmit)="createEditNamespace()" [formGroup]="namespaceForm">
      <div class="form-group">
        <label class="d-block">
          <label labelfor="azureAccountId" class="input-label">* Azure Account</label>
          <select [attr.disabled]="this.azureNamespaceId && this.azureNamespaceId > 0 ? '' : null"
            [ngModelOptions]="{standalone: true}" placeholder="Select an account" type="number"
            [(ngModel)]="selectedAzureAccount">
            <option *ngFor="let account of azureAccounts" [ngValue]="account">{{account.AccountName}}</option>
          </select>
          <label [ngClass]="isAccountSelected ? '' : 'active'" class="error">Azure account is a
            required field.</label>
        </label>
      </div>

      <div class="form-group">
        <label class="d-block">
          <label labelfor="namespace" class="input-label">* Namespace</label>
          <input type="text" id="namespace" placeholder="Enter your Azure namespace" formControlName="azurenamespace" />
          <label [ngClass]="isNamespaceEntered ? '' : 'active'" class="error">Azure account name is a required
            field.</label>
        </label>
      </div>
      <div *ngIf="!(this.azureNamespaceId && this.azureNamespaceId > 0)" class="text-right">
        <a (click)="checkAvailability()" class="btn btn-sm btn-info">Check Availablility</a>
      </div>

      <div class="form-group">
        <label class="d-block">
          <label class="input-label">* Location</label>
          <select [attr.disabled]="this.azureNamespaceId && this.azureNamespaceId > 0 ? '' : null"
            [ngModelOptions]="{standalone: true}" placeholder="Select location" type="number"
            [(ngModel)]="selectedLocation">
            <option *ngFor="let location of locations" [ngValue]="location">{{location.LocationName}}</option>
          </select>
          <label [ngClass]="isLocationSelected ? '' : 'active'" class="error">Location is a
            required field.</label>
        </label>
      </div>

      <div class="form-group">
        <label class="d-block">
          <label labelfor="resourceGroup" class="input-label">* Resource Group</label>
          <input type="text" id="resourceGroup" placeholder="Enter Azure resource group"
            formControlName="resourceGroup" />
          <label [ngClass]="isResourceGroupEntered ? '' : 'active'" class="error">Resource group is a required
            field.</label>
        </label>
      </div>

      <div *ngIf="this.azureNamespaceId && this.azureNamespaceId > 0" class="form-group">
        <label class="d-block">

          <label style="color:#000" class="container-checkbox">
            Active
            <input type="checkbox" formControlName="checkActive" />
            <span class="checkmark"></span>
          </label>
        </label>
      </div>


      <div class="form-group">
        <button type="submit" class="btn btn-success btn-login" type="submit">
          <span [hidden]="isLoading">Save</span>
          <span [hidden]="!isLoading">
            <i class="fas fa-spinner fa-pulse"></i>
          </span>
        </button>
        <div [hidden]="!isErrorVisible" class="alert alert-danger mt-2" role="alert">
          {{error}}
        </div>

        <div [hidden]="!isSuccessVisible" class="alert alert-success mt-2" role="alert">
          {{success}}
        </div>

      </div>
    </form>
  </div>
</div>
